<div *ngIf="data.inputData.image" class="w-full">
    <div class="relative w-full aspect-video">
        <!-- Container for the image and spinner -->
        <div class="w-full h-full relative">
            <!-- Loading spinner -->
            <div class="absolute inset-0 flex items-center justify-center" *ngIf="!imageLoaded">
                <mat-spinner diameter="30" color="accent"></mat-spinner>
            </div>

            <!-- Image loading error indicator -->
            <div class="absolute inset-0 flex flex-col items-center justify-center bg-gray-200 dark:bg-zinc-700" *ngIf="imageError">
                <mat-icon class="text-5xl text-gray-500 dark:text-zinc-400">broken_image</mat-icon>
            </div>

            <!-- Responsive image with optimized sources and fallbacks -->
            <picture *ngIf="!imageError">
                <!-- WebP format - first choice for compatible browsers -->
                <source [srcset]="getItemImageSrcSet(data.inputData)" type="image/webp">
                <!-- JPEG format - fallback for browsers that don't support WebP -->
                <source [srcset]="getItemFallbackImageUrl(data.inputData)" type="image/jpeg">
                <!-- Final fallback image for browsers that don't support picture -->
                <img
                    [src]="getItemFallbackImageUrl(data.inputData)"
                    [alt]="getItemName(data.inputData)"
                    class="w-full h-full object-cover"
                    loading="lazy"
                    (load)="onImageLoad()"
                    (error)="onImageError()"
                    [ngClass]="{'opacity-0': !imageLoaded}"
                />
            </picture>
        </div>
    </div>
</div>

<div class="w-full px-4 pt-4 pb-8">
    <div class="flex flex-col">
        <h2 class="m-0 text-xl font-semibold text-zinc-800 dark:text-zinc-100 leading-7">{{ getItemTitle(data.inputData) }}</h2>
    </div>

    <!-- Unit price or price options -->
    <div class="mt-1">
        <ng-container *ngIf="data.inputData.singlePrice; else priceOptions">
            <p class="m-0 text-lg font-semibold text-zinc-800 dark:text-zinc-100">
                {{ data.inputData.price | menuPrice:establishment.currencyCode:currentLocale }}
            </p>
        </ng-container>

        <ng-template #priceOptions>
            <ul class="menu_section_dish_price not-prose" [ngClass]="{'price_options_horizontal': getAvailablePriceOptions().length <= 2, 'price_options_vertical': getAvailablePriceOptions().length > 2}">
                <li *ngFor="let option of getAvailablePriceOptions()" data-price_variant="{{option.uuid}}">
                    <span class="price_text dark:text-zinc-100">{{ getPriceOptionName(option) }}:</span>
                    <span class="nowrap dark:text-zinc-100">
                        {{ option.price | menuPrice:establishment.currencyCode:currentLocale }}
                    </span>
                </li>
            </ul>
        </ng-template>
    </div>

    <p class="m-0 mt-3 text-sm text-zinc-500 dark:text-zinc-400 leading-5">{{ getItemDescription(data.inputData) }}</p>
    
    <!-- Food Type Tags -->
    <div class="flex flex-wrap gap-2 mt-4" *ngIf="data.inputData.tags && data.inputData.tags.length > 0">
        <div *ngFor="let tag of data.inputData.tags" 
             class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100 dark:bg-zinc-800"
             [ngClass]="getFoodTypeClasses(tag)">
            <i [class]="getFoodTypeIcon(tag)"
               class="me-2"
               >
            </i>
            <span class="dark:text-zinc-300">{{ 'common.refs.tags.' + tag | transloco }}</span>
        </div>
    </div>

    <!-- Allergens Tags -->
    <div class="mt-6" *ngIf="data.inputData.allergens && data.inputData.allergens.length > 0">
        <h3 class="text-lg font-semibold mb-2 dark:text-zinc-100">{{ 'common.labels.allergens' | transloco }}</h3>
        <div class="flex flex-wrap gap-2">
            <div *ngFor="let allergen of data.inputData.allergens" 
                class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100 dark:bg-zinc-800"
                [ngClass]="getAllergenClasses()">
                <i [class]="getAllergenIcon(allergen)"
                   class="me-2"
                   >
                </i>
                <span class="dark:text-zinc-300">{{ 'common.refs.allergens.' + allergen | transloco }}</span>
            </div>
        </div>
    </div>
</div>
